// Combines original image + W1 mask for preview modes

import { WhiteLayerPreviewMode } from "../../types/whiteLayer";

/**
 * Builds a preview canvas output depending on mode:
 * - original: untouched
 * - w1: grayscale mask only
 * - overlay: original + simulated white behind
 */
export function buildPreviewOverlay(
  original: ImageData,
  mask: ImageData,
  mode: WhiteLayerPreviewMode
): ImageData {
  const { width, height } = original;

  const output = new ImageData(width, height);

  for (let i = 0; i < original.data.length; i += 4) {
    const r = original.data[i];
    const g = original.data[i + 1];
    const b = original.data[i + 2];
    const a = original.data[i + 3];

    const maskGray = mask.data[i]; // already grayscale

    if (mode === "original") {
      output.data[i] = r;
      output.data[i + 1] = g;
      output.data[i + 2] = b;
      output.data[i + 3] = a;
      continue;
    }

    if (mode === "w1") {
      output.data[i] = maskGray;
      output.data[i + 1] = maskGray;
      output.data[i + 2] = maskGray;
      output.data[i + 3] = 255;
      continue;
    }

    // overlay mode
    // simulate white behind by blending
    // lower maskGray = stronger white

    const whiteStrength = 1 - maskGray / 255;

    const boostedR = r + (255 - r) * whiteStrength;
    const boostedG = g + (255 - g) * whiteStrength;
    const boostedB = b + (255 - b) * whiteStrength;

    output.data[i] = Math.min(255, boostedR);
    output.data[i + 1] = Math.min(255, boostedG);
    output.data[i + 2] = Math.min(255, boostedB);
    output.data[i + 3] = a;
  }

  return output;
}
